import queryString from "query-string";

const useParameterUrl  = () => {
    const searchParameter = window.location.search;
    const data = queryString.parse(searchParameter);
    return data;
}

export default useParameterUrl;
